import React from "react";
import RootLookbook from "container/lookbook/RootLookbook";
import RootLounge from "container/lounge/RootLounge";
import { useLocation, Redirect } from "react-router-dom";
import { withStore } from "store/storeHandler";
import { getEssentialUrl } from "lib/urlQueryParser";

function RootOpening(props) {
  const { hasLoggedIn, username } = props;

  const location = useLocation();
  const { pathname } = location;

  const lookbookPath = getEssentialUrl({ type: "lookbook" })();
  const openingPath = getEssentialUrl({ type: "opening" })();
  const portfolioPath = getEssentialUrl({ type: "portfolio" })(username);

  if (pathname === lookbookPath) {
    return hasLoggedIn ? <RootLookbook /> : <Redirect to={openingPath} />;
  }

  if (pathname === openingPath) {
    return hasLoggedIn ? <Redirect to={portfolioPath} /> : <RootLounge />;
  }

  return <Redirect to={openingPath} />;
}

export default withStore({
  stateMap: { myAccount: ["hasLoggedIn", "username"] }
})(RootOpening);
